import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';
import { addOnSchema } from './add-on';

export const mobileProductSchema = z.object({
  productId: z.number().min(1),
  name: z.string().min(1),
  addons: z.array(addOnSchema).nullable().optional(),
  numberOfLicenses: z.number().min(1),
  active: z.boolean(),
  expirationDate: coercedDate.nullable(),
  purchaseOrderNumber: z.string().optional(),
});

export type MobileProduct = z.infer<typeof mobileProductSchema>;
